import { render } from "./VehicleInspectionReport.vue?vue&type=template&id=6de41f5a&scoped=true&ts=true"
import script from "./VehicleInspectionReport.vue?vue&type=script&lang=ts"
export * from "./VehicleInspectionReport.vue?vue&type=script&lang=ts"

import "./VehicleInspectionReport.vue?vue&type=style&index=0&id=6de41f5a&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\TTI.AVE.Web\\Vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6de41f5a"]])

export default __exports__